// extracted by mini-css-extract-plugin
module.exports = {"variablesDataType":"VariablesBooleanDataType_variablesDataType__qA2Qu"};